import React from 'react';
import { Shield, User } from 'lucide-react';
import { Badge } from '../@/components/ui/badge';

interface RoleBadgeProps {
  role: 'DM' | 'Player';
  showLabel?: boolean;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ role, showLabel = true }) => {
  return (
    <Badge
      variant={role === 'DM' ? 'destructive' : 'secondary'}
      className="flex items-center gap-1"
    >
      {role === 'DM' ? <Shield className="h-3 w-3" /> : <User className="h-3 w-3" />}
      {showLabel && (role === 'DM' ? 'Dungeon Master' : 'Player')}
    </Badge>
  );
};

export default RoleBadge;